export default __webpack_public_path__ + "static/media/workshop2.c3be90a2.jpg";